export default __webpack_public_path__ + "static/media/home-image-button-online-bible.76e95691.jpg";